import { JobEvent } from "../../../DataModels/DataModels";
import HistoryEvent from "./HistoryEvent";
import EmptyHistoryState from "./EmptyHistoryState";

interface HistoryTimelineProps {
	events: JobEvent[];
}

const HistoryTimeline: React.FC<HistoryTimelineProps> = ({ events }) => {
	if (!events.length) {
		return <EmptyHistoryState />;
	}

	return (
		<div className="py-2">
			{events.map((event, index) => (
				<HistoryEvent
					key={event.eventId}
					event={event}
					isLast={index === events.length - 1}
				/>
			))}
		</div>
	);
};

export default HistoryTimeline;
